<template>
  <v-dialog
      :value="changePasswordModel"
      max-width="30%"
      persistent
      scrollable
  >
    <v-form ref="password_form">
      <v-card ref="card">
        <v-card-title>
          Change Password
        </v-card-title>
        <v-card-text class="pt-4">
          <v-row>
            <v-col cols="12" md="12">
              <label for="">
                New Password
              </label>
              <v-text-field
                  v-model="password.password"
                  :append-icon="password.new_hide ? 'mdi-eye-off' : 'mdi-eye'"
                  :rules="[
                    (v) => !!v || 'Password is required',
                    (v) => (v && v.length >= 6) || 'Password should be at least 6 characters long',
                  ]"
                  :type="password.new_hide ? 'password' : 'text'"
                  background-color="#fff"
                  outlined
                  required
                  dense
                  hide-details="auto"
                  class="q-text-field"
                  @click:append="password.new_hide = !password.new_hide"
              />
            </v-col>
            <v-col cols="12" md="12">
              <label for="">
                Confirm Password
              </label>
              <v-text-field
                  v-model="password.password_confirmation"
                  :append-icon="password.confirm_hide ? 'mdi-eye-off' : 'mdi-eye'"
                  :rules="confirmRules()"
                  :type="password.confirm_hide ? 'password' : 'text'"
                  outlined
                  required
                  dense
                  hide-details="auto"
                  class="q-text-field"
                  @click:append="password.confirm_hide = !password.confirm_hide"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="ma-2" text @click="$emit('close')">Close</v-btn>
          <v-btn class="ma-2 white--text blue-color" text @click="changePassword">Change Password</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  props: {
    changePasswordModel: Boolean,
    venueForm: Object
  },
  data(){
    return {
      password:{
        user_id: null,
        current_hide: false,
        new_hide: true,
        confirm_hide: true,
      }
    }
  },
  methods: {
    confirmRules() {
      let rules = [];
      if (this.password.password_confirmation == null) {
        rules.push("Confirm password is required");
      }
      if (this.password.password_confirmation !== this.password.password) {
        rules.push("Confirm password does not match");
      }
      return rules;
    },
    changePassword() {
      this.password.user_id = this.venueForm.admin_user_id;
      if (!this.$refs.password_form.validate()) {
        this.showError("Please fill all required fields");
        return;
      }
      this.showLoader();
      this.$http
          .put("venues/users/update-new-password", this.password)
          .then((response) => {
            if (response.status === 200) {
              this.hideLoader();
              this.$emit("close");
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
  }
};
</script>

<style scoped>
/* Add scoped styles if needed */
</style>
